import useFormatCurrencyForSrp from '@/src/hooks/currency/useFormatCurrencyForSrp'
import { useGetRTSolutionCardData } from '@/src/hooks/srp/RTSolutionView/getRTSolutionCardData'
import { FlightCard } from '@/src/types/flight'
import { Circle } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'

const SelectedOnwardPriceInfo = ({ flightData }: { flightData: FlightCard }) => {

    const { formatCurrency } = useFormatCurrencyForSrp()
    const { price } = useGetRTSolutionCardData(flightData)

    return (
        <Box display={'flex'} gap={0.5} alignItems={'center'}>
            <Circle sx={{ fontSize: 3, color: "#4B5563" }} />
            <Typography

                sx={{
                    fontWeight: 600,
                    fontSize: '14px',
                }}
            >
                {formatCurrency(price)}
            </Typography>
        </Box>
    )
}

export default SelectedOnwardPriceInfo
